<template>
  <div class="pa-5">
    <v-card shaped class="elevation-10">
      <v-card-title>{{ `แบบฟอร์ม${form_title}ข่าวสาร${recruit_id ? '(ประกาศผล)' : ''}` }}</v-card-title>
      <v-card-text>
        <input hidden type="file" accept="image/*" ref="cover_input" @change="cover_change">
				<div class="d-flex justify-center cover-zone" @click="toggle_cover()">
					<img class="img-fluid pa-2" v-if="cover_preview" :src="cover_preview">
					<h4 class="py-10" v-if="!cover_preview">รูปภาพหน้าปก (ไม่บังคับ)</h4>
				</div>
      </v-card-text>
      <v-card-text class="pt-0">
        <v-radio-group v-model="form.news_type_id" row v-if="!recruit_id">
          <v-radio v-for="type in news_types" :key="type.id" :value="type.id" :label="type.name_th" :disabled="type.id == 3 && form_type !== 'ANNOUNCEMENT'"></v-radio>
        </v-radio-group>
        <v-text-field v-model="form.headline_th" outlined dense label="หัวข้อข่าว"></v-text-field>
        <editor v-model="form.content_th" :init="editor_config"/>
        <v-file-input v-model="form.files" class="mt-5" dense outlined multiple accept="application/pdf" label="แนบไฟล์ PDF"></v-file-input>
      </v-card-text>
      <v-card-actions class="d-flex flex-row justify-center">
        <v-btn color="success" @click="submit">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import tinymceConfig from './tinymce_config.js';

export default {
  components: {
		editor: Editor
  },
  data: () => ({
    editor_config: tinymceConfig,
    form: {
      news_type_id: 1,
      headline_th: '',
      content_th: '',
      recruit_id: '',
      cover: null,
      files: null
    },
    cover_preview: '',
  }),
  computed: {
    form_type() { return this.$route.meta.form_type },
    form_title() { return this.$route.meta.form_title },
    news_types() { return this.$store.state.news.news_types },
    recruit_id() { return this.$route.params.recruit_id }
  },
  mounted() {
    if(this.form_type === 'EDIT') {
      this.$store.dispatch('news/edit_news', this.$route.params.id)
        .then(data => {
          this.form = {
            id: data.id,
            news_type_id: data.news_type_id,
            headline_th: data.headline_th,
            content_th: data.content_th
          }
          
          if(data.cover_path) {
            this.cover_preview = `${process.env.VUE_APP_URL}/storage/news/images/covers/${data.cover_path}`;
          }
        });
    } else if(this.form_type === 'ANNOUNCEMENT') {
      this.form.recruit_id = this.$route.params.id;
      this.form.news_type_id = 3;
    }
  },
  methods: {
    toggle_cover() { this.$refs.cover_input.click(); },
    cover_change(event) {
      const files = event.target.files || event.dataTransfer.files;

			if(!files.length) { 
				return; 
			} else {
				this.cover_preview = URL.createObjectURL(files[0]);
				this.form.cover = files[0];
			}      
    },
		createFormData(form) {
			let formData = new FormData;

      formData.append('news_type_id', form.news_type_id);
      formData.append('headline_th', form.headline_th);
      formData.append('content_th', form.content_th);
      formData.append('recruit_id', form.recruit_id);

      if(form.id) {
        formData.append('id', form.id);
      }

			if(form.cover) {
        console.log(form.cover);
				formData.append('cover', form.cover);
			}

			if(form.files) {
        console.log(form.files);
        form.files.forEach(item => {
          formData.append('files[]', item);
        });
      }
      
			return formData;
    },
    submit() {
      this.$store.dispatch(`${this.form_type === 'CREATE' || this.form_type === 'ANNOUNCEMENT' ? 'news/store_news' : 'news/update_news'}`, this.createFormData(this.form)).then(() => {
        this.$router.push({ name: 'NewsList' });
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: 'บันทึกข้อมูลสำเร็จ'
        });
      }).catch(() => {
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'error',
          message: 'เกิดข้อผิดพลาดบางอย่าง'
        });
      });
    }
  }
}
</script>

<style lang="scss">
  .cover-zone {
    border: 2px dashed;
    cursor: pointer;
  }
  .img-fluid {
    width: 100%;
  }
</style>